import type { IWebshopMessageDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import { useSessionStorage } from 'usehooks-ts';
import { useCallback, useMemo } from 'react';
import { useHydrated } from 'remix-utils/use-hydrated';
import { useAreaLayoutLoaderData } from '~/common/utils/useAreaLayoutLoaderData';

export const WEBSHOPMESSAGE_OPEN_KEY = 'messagesOpen';
export const WEBSHOPMESSAGE_SESSION_STORAGE_KEY = 'markedMessagesInSession';
export const WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT = 'IMPORTANT_MESSAGE_BGH';
export const WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT = 'IMPORTANT_MESSAGE_AGH';
export const WEBSHOPMESSAGE_TYPE_GENERAL = 'INFORMATION_MESSAGE_AGH_BGH';

export function useWebshopMessages() {
  const [isDialogOpen, setIsDialogOpen] = useSessionStorage<boolean>(WEBSHOPMESSAGE_OPEN_KEY, false);
  const isHydrated = useHydrated();

  const layoutLoaderData = useAreaLayoutLoaderData();
  const webshopMessages = useMemo(() => layoutLoaderData?.webshopMessages ?? [], [layoutLoaderData]);

  const [markedMessagesInSession, setSessionConfirmedNotifications] = useSessionStorage<number[]>(
    WEBSHOPMESSAGE_SESSION_STORAGE_KEY,
    []
  );

  const visibleMessages = useMemo(() => {
    const notMarkedMessages = webshopMessages.filter(message => !markedMessagesInSession.includes(message.id));

    return [...notMarkedMessages];
  }, [markedMessagesInSession, webshopMessages]);

  const markAsRead = useCallback(
    (message: IWebshopMessageDtoData) => {
      setSessionConfirmedNotifications(prevState => [...prevState, message.id]);
    },
    [setSessionConfirmedNotifications]
  );

  const showNotificationBell = useMemo(
    () => isHydrated && webshopMessages.length > 0 && visibleMessages.length < webshopMessages.length,
    [isHydrated, webshopMessages, visibleMessages]
  );

  const shouldShowMessages = useMemo(() => {
    return visibleMessages.length > 0;
  }, [visibleMessages]);

  return {
    messages: webshopMessages,
    visibleMessages,
    markAsRead,
    showNotificationBell,
    setIsDialogOpen,
    isDialogOpen,
    shouldShowMessages
  };
}
